import {config} from '../config';

export default {
    getIsAccessibilityToolEnabled: () => config.data.accessibility.isToolEnabled,
    getAccessibilityClassMapping: () => config.data.accessibility.classMapping,
};
